import React, { useRef } from 'react';
import { useUser } from '../app';

const IS_PRODUCTION = process.env.NODE_ENV === "production";
const BACKEND_URI = IS_PRODUCTION ? process.env.REACT_APP_API_BASE_URI : "http://localhost:5050";

export function LoginForm() {
    const formRef = useRef(null);
    const { user, setUser } = useUser();

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission

        const formData = new FormData(formRef.current); // Create FormData object from the form
        const data = Object.fromEntries(formData);

        try {
            const response = await fetch(`${BACKEND_URI}/login`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data),
                credentials: 'include' // Include cookies
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            if (result.success) {
                setUser({ username: result.username });
                console.log('Logged in as:', result.username);
            } else {
                alert(result.details);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Login failed');
        }
    };

    const logout = async () => {
        try {
            await fetch(`${BACKEND_URI}/logout`, {
                method: 'POST',
                credentials: 'include'
            });
            setUser(null);
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    return (
        <div className="header-login-details">

            {user ? (

                <div className="login-info"> 
                    {user.username === "Business Tonka" ? (
                            <div id="tonka-picture"> 
                                <img src="/images/tutorials/BusinessTonka.png" alt="Business Tonka Easteregg" />
                            </div>
                        ) : (
                            <div />
                        )}
                    <h3>{user.username}</h3>
                    <button onClick={logout}>Logout</button>
                </div>
            ) : (
                <div className="login-info">
                    <form ref={formRef} onSubmit={handleSubmit}>
                        <input type="text" name="username" placeholder="Username" required />
                        <input type="password" name="password" placeholder="Password" required />

                        <input type="submit" value="Login" id="login" />
                    </form>
                </div>
            )}
        </div>
    );
}
